import { IMealtime } from 'src/types/mealtimes.types';

export const filterMealtimesWithCategories = (mealtimes: IMealtime[]): IMealtime[] =>
  mealtimes.filter((mealtime: IMealtime) => mealtime?.categories?.length);
